import { Chain } from "@swapkit/core";

import { ForgeTNS } from "./types";

export const thorname = {
  id: Math.floor(Math.random() * 1000000),
  type: "listing",
  name: "chad",
  owner: "chadthorowner.thor",
  nameWithExtension: "chad.thor",
  price: {
    rune: 135.05,
    usd: 269.28,
  },
  fee: "11.05",
  entries: [{ address: "0x123", chain: Chain.Ethereum }],
  buyer: null,
  escrowWalletId: 1,
  status: "active",
  escrowWallet: {
    address: "thor123213123123mockaddress",
  },
  activeOffers: [],
  activity: [],

  transferFeeDetails: null,
  transferThornameDetails: null,
  transferBuyDetails: null,
  transferTNSToNewOwnerDetails: null,
  transferForgeFeeDetails: null,
  transferProfitToPreviousOwnerDetails: null,

  createdAt: new Date(),
  updatedAt: new Date(),
  soldAt: new Date(),
  expiresAt: new Date(),
};

export const suggestedThornames = Array.from({ length: 10 }).fill(thorname) as ForgeTNS[];
